import {Action} from "@ngrx/store";

export const LOAD_ECOMMERCE_TAX_RATES: string = '[ecommerce Tax Rates] Load Ecommerce Tax Rates';
export const LOAD_ECOMMERCE_TAX_RATES_SUCCESS: string = '[ecommerce Tax Rates] Load Ecommerce Tax Rates Success';
export const LOAD_ECOMMERCE_TAX_RATES_FAIL: string = '[ecommerce Tax Rates] Load Ecommerce Tax Rates Fail';

export class LoadEcommerceTaxRates implements Action {
  readonly type: string = LOAD_ECOMMERCE_TAX_RATES;

  constructor(public payload: { websiteId: number }) {
  }
}

export class LoadEcommerceTaxRatesSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_TAX_RATES_SUCCESS;

  constructor(public payload: {
    data: any,
    loaded?: boolean,
    loading?: boolean,
    websiteId: number
  }) {
  }

}

export class LoadEcommerceTaxRatesFail implements Action {

  readonly type: string = LOAD_ECOMMERCE_TAX_RATES_FAIL;

  constructor(public payload: any) {
  }

}

export type EcommerceTaxRatesAction = LoadEcommerceTaxRates | LoadEcommerceTaxRatesSuccess | LoadEcommerceTaxRatesFail;
